import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Design from '@/views/design.vue'
import Login from '@/views/loginAuth.vue'
import { useUserStore } from '@/stores/user'

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/editor' },
  { path: '/editor', name: 'Editor', component: Design },
  { path: '/loginAuth', name: 'Login', component: Login },
  { path: '/:pathMatch(.*)*', redirect: '/editor' }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

// router.beforeEach((to, _from, next) => {
//   const userStore = useUserStore()
//   userStore.loadFromStorage()
//   if (to.path === '/login' && userStore.isLoggedIn) {
//     const query: any = { ...to.query }
//     delete query.key
//     query.mode = 'user'
//     next({ name: 'Editor', query, hash: to.hash })
//   } else if (to.path == '/' && userStore.isLoggedIn) {

//     // key = 0c636b15e97b1e586 & id=16631 & design_admin_id=31 & create_tag=1 & order_no=ceshi_zzy & increment _id = 4 & now_state=待审图
//     const query: any = { ...to.query }
//     delete query.key
//     query.mode = 'user'
//     next({ name: 'Login', query, hash: to.hash })
//   } else if (to.path !== '/login' && !userStore.isLoggedIn) {

//     next({ name: 'Login', query: to.query, hash: to.hash })
//   } else {
//     next()
//   }
// })

export default router
// https://design.aishanyin.com/zh-CN/editor?id=16633&mode=user&create_tag=1&design_admin_id=20&order_no=JY202511241949&increment_id=51474&now_state=%E5%BE%85%E5%81%9A%E5%9B%BE
// http://localhost:8080/editor?                id=16631&mode=user&design_admin_id=31&create_tag=1&order_no=ceshi_zzy&increment_id=4&now_state=%E5%BE%85%E5%AE%A1%E5%9B%BE